/**
 * WaitingListFilters - Filtros seguindo mockup v2.
 * Período (date range), Profissional, Procedimento, Ordenar por.
 */
import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import styles from '../WaitingListV2Page.module.css';

function WaitingListFilters({ filters, onFilterChange, resources = [], procedures = [], activeTab }) {
  const isSlotTab = activeTab === 'SLOTS';

  return (
    <div className={styles.filtersContainer}>
      {/* Date range - only for slots tab */}
      {isSlotTab && (
        <>
          <div className={styles.filterGroup}>
            <span className={styles.filterLabel}>Período</span>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <TextField
                type="date"
                size="small"
                value={filters.startDate || ''}
                onChange={(e) => onFilterChange({ ...filters, startDate: e.target.value })}
                InputLabelProps={{ shrink: true }}
                sx={{ width: 150, '& .MuiInputBase-input': { fontSize: '0.82rem' } }}
              />
              <span style={{ color: '#94a3b8', fontSize: '0.8rem' }}>—</span>
              <TextField
                type="date"
                size="small"
                value={filters.endDate || ''}
                onChange={(e) => onFilterChange({ ...filters, endDate: e.target.value })}
                InputLabelProps={{ shrink: true }}
                sx={{ width: 150, '& .MuiInputBase-input': { fontSize: '0.82rem' } }}
              />
            </div>
          </div>
        </>
      )}

      {/* Professional */}
      <div className={styles.filterGroup}>
        <span className={styles.filterLabel}>Profissional</span>
        <FormControl size="small" sx={{ minWidth: 140 }}>
          <Select
            value={filters.resourceId || ''}
            onChange={(e) => onFilterChange({ ...filters, resourceId: e.target.value })}
            displayEmpty
            sx={{ fontSize: '0.82rem' }}
          >
            <MenuItem value="">Todos</MenuItem>
            {resources.filter(r => r.Active == 1 || r.Active === undefined).map((r) => (
              <MenuItem key={r.Id} value={r.Id}>{r.Label}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      {/* Procedure */}
      <div className={styles.filterGroup}>
        <span className={styles.filterLabel}>Procedimento</span>
        <FormControl size="small" sx={{ minWidth: 140 }}>
          <Select
            value={filters.procedureId || ''}
            onChange={(e) => onFilterChange({ ...filters, procedureId: e.target.value })}
            displayEmpty
            sx={{ fontSize: '0.82rem' }}
          >
            <MenuItem value="">Todos</MenuItem>
            {procedures.filter(p => p.Active == 1 || p.Active === undefined).map((p) => (
              <MenuItem key={p.Id} value={p.Id}>{p.Label}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      {/* Sort - only for slots tab */}
      {isSlotTab && (
        <div className={styles.filterGroup}>
          <span className={styles.filterLabel}>Ordenar por</span>
          <FormControl size="small" sx={{ minWidth: 180 }}>
            <Select
              value={filters.sortBy || 'compatibility'}
              onChange={(e) => onFilterChange({ ...filters, sortBy: e.target.value })}
              sx={{ fontSize: '0.82rem' }}
            >
              <MenuItem value="compatibility">Melhor compatibilidade</MenuItem>
              <MenuItem value="date">Data mais próxima</MenuItem>
              <MenuItem value="patients">Mais pacientes</MenuItem>
            </Select>
          </FormControl>
        </div>
      )}

      {/* Status filter - only for patients tab */}
      {!isSlotTab && (
        <div className={styles.filterGroup}>
          <span className={styles.filterLabel}>Status</span>
          <FormControl size="small" sx={{ minWidth: 130 }}>
            <Select
              value={filters.status || ''}
              onChange={(e) => onFilterChange({ ...filters, status: e.target.value })}
              displayEmpty
              sx={{ fontSize: '0.82rem' }}
            >
              <MenuItem value="">Todos</MenuItem>
              <MenuItem value="PENDING">Pendente</MenuItem>
              <MenuItem value="CONTACTED">Contatado</MenuItem>
              <MenuItem value="SCHEDULED">Agendado</MenuItem>
              <MenuItem value="DECLINED">Recusado</MenuItem>
            </Select>
          </FormControl>
        </div>
      )}
    </div>
  );
}

export default WaitingListFilters;
